import Colors from '@dynatrace/strato-design-tokens/colors';
import Spacings from '@dynatrace/strato-design-tokens/spacings';
import Typography from '@dynatrace/strato-design-tokens/typography';
import { format } from '@dynatrace-sdk/units';

import type { LabelAlignment } from './types/range-legend.internal.js';
import type { TruncationMode } from '../../../../../typography/text-ellipsis/TextEllipsis.js';
import type { MappedObject } from '../../../types/helpers/mapped-object.js';

const getNumberFromString = (value: string): number => {
  const extractedNumber = value.match(/\d+/);

  return extractedNumber ? +extractedNumber[0] : 0;
};

export const LABEL_ALIGNMENT: MappedObject<LabelAlignment> = {
  Start: 'start',
  Center: 'center',
  End: 'end',
};

export const TRUNCATION_MODE: MappedObject<TruncationMode> = {
  End: 'end',
  Middle: 'middle',
  Start: 'start',
};

export const DEFAULT_TRUNCATION_MODE = TRUNCATION_MODE.Middle;
// TODO: APPDEV-10243 Check default formatter with UX
export const DEFAULT_FORMATTER = (value: number) => format(value);
export const DEFAULT_ITEM_THICKNESS = 10;
export const DEFAULT_SEGMENT_SIZE = 6;
export const DEFAULT_SEGMENT_COLOR = Colors.Background.Field.Neutral.Disabled;
export const DEFAULT_GAP_THICKNESS = 1;
export const DEFAULT_LABEL_FONT_SIZE = Typography.Text.Small.Default.Size;
export const DEFAULT_LABEL_FONT_COLOR = Colors.Text.Neutral.Subdued;
export const LABEL_FONT_COLOR_HOVERED = Colors.Text.Neutral.Default;
export const LABEL_FONT_WEIGHT = Typography.Text.Small.Default.Weight;
export const HOVERED_LABEL_FONT_WEIGHT =
  Typography.Text.Small.Emphasized.Weight;
export const GAP_BETWEEN_LABELS = 8;
export const TEXT_ELLIPSIS = '...';
export const STROKE_WIDTH = 1;
export const MAX_LEGEND_HEIGHT = 360;
export const MAX_LEGEND_WIDTH = 360;
export const CSS_CONTAINER_PADDING = Spacings.Size8;
export const LABEL_HOVERED_PADDING = getNumberFromString(Spacings.Size8);
export const LABEL_GAP = getNumberFromString(Spacings.Size2);
export const CONTAINER_PADDING = getNumberFromString(CSS_CONTAINER_PADDING);
export const DEFAULT_CONTAINER_SIZE =
  DEFAULT_ITEM_THICKNESS + CONTAINER_PADDING * 2;

export const RANGE_LEGEND_CLASS = 'range-legend';

export const OVERLAY_ADDITIONAL_SIZE = getNumberFromString(Spacings.Size8);
export const OVERLAY_OFFSET = OVERLAY_ADDITIONAL_SIZE / 2;
